import { render, staticRenderFns } from "./PagamentoAnexos2.vue?vue&type=template&id=0cfc53d4&"
import script from "./PagamentoAnexos2.vue?vue&type=script&lang=js&"
export * from "./PagamentoAnexos2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports